<template>
  <div :class="device.desktop ? `home pa-6 grey lighten-4`:`home pa-0 grey lighten-4`">

    <v-row class="pa-1">
      <v-spacer></v-spacer>
      <v-col :cols="device.desktop ? `12` : `12`">
        <v-card class="animated animate__bounceIn">
          <v-toolbar
            :color="theme.color"
            :dark="theme.mode"
            class=" animate__animated animate__fadeInDown"
            flat
          >
            <div class="rounded-pill white pb-1 pr-5 pt-1">
              <v-icon
                color="blue"
                class="ml-1  mr-1  "
              >mdi-circle</v-icon> <span class="blue--text">
                Formulir Ubah Produk
              </span>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="$router.push({name:'umkm-product'})"
            >
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row class="mt-1">
              <v-col cols="12">
                <v-select
                  label="Kategori"
                  outlined
                  dense
                  hide-details
                  :color="theme.color"
                  :items="categories"
                  v-model="record.category_uuid"
                  @change="fetchSubCategories"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="Sub Kategori"
                  outlined
                  dense
                  hide-details
                  :color="theme.color"
                  v-model="record.sub_category_uuid"
                  :items="subcategories"
                ></v-select>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Nama Produk"
                  outlined
                  dense
                  hide-details
                  v-model="record.name"
                  :color="theme.color"
                ></v-text-field>
              </v-col>

              <v-col cols=12>
                <tiptap-vuetify
                  v-model="record.description"
                  :extensions="extensions"
                  placeholder="Penjelasan Produk"
                />
              </v-col>
              <v-col cols=12>
                <tiptap-vuetify
                  v-model="record.spec"
                  :extensions="extensions"
                  placeholder="Spesifikasi Produk"
                />
              </v-col>
              <v-col cols=12>
                <tiptap-vuetify
                  v-model="record.info"
                  :extensions="extensions"
                  placeholder="Informasi Penting"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  label="Satuan"
                  outlined
                  dense
                  hide-details
                  :color="theme.color"
                  v-model="record.unit_uuid"
                  :items="units"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Harga"
                  outlined
                  dense
                  hide-details
                  v-model="record.price"
                  :color="theme.color"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-card
                  flat
                  outlined
                >
                  <v-col cols="12">
                    <v-row class="px-5  py-2 grey--text grey lighten-3">
                      <div>Daftar Gambar Produk (Minimal 1 Gambar)</div>
                      <v-spacer></v-spacer>
                      <div>
                        <v-tooltip
                          :color="theme.color"
                          bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              text
                              small
                              icon
                              v-on="on"
                              color="white"
                              class="animate__animated animate__heartBeat animate__delay-1s"
                              @click="uploadFoto"
                            >
                              <v-icon color="grey">mdi-plus-circle</v-icon>
                            </v-btn>
                          </template>
                          <span>Tambah Gambar Produk</span>
                        </v-tooltip>
                      </div>
                    </v-row>
                  </v-col>
                  <v-card-text>
                    <v-row>
                      <v-col
                        :cols="device.desktop ? 3: 12"
                        v-for="(item, index) in images"
                        :key="index"
                      >
                        <v-card class="flat outlined text-center pa-2">

                          <img
                            :src="item.path"
                            alt="Gambar Produk"
                            srcset=""
                            width="200"
                            height="200"
                          >
                          <v-card-actions>
                            <v-btn
                              block
                              outlined
                              small
                              :color="theme.color"
                              @click="deleteFoto(index)"
                            >Hapus</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col :cols="device.desktop ? 3:12">
                    <v-switch
                      label="Tampilkan"
                      outlined
                      dense
                      hide-detail
                      v-model="record.status"
                      :color="theme.color"
                    ></v-switch>
                  </v-col>
                  <v-col :cols="device.desktop ? 3:12">
                    <v-switch
                      label="Produk Unggulan"
                      outlined
                      dense
                      hide-detail
                      v-model="record.unggulan"
                      :color="theme.color"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>

            </v-row>
          </v-card-text>

          <v-card-actions class="mt-5">

            <v-col class="text-right">
              <v-btn
                outlined
                :color="theme.color"
                @click="posthRecord"
                rounded
              >SIMPAN</v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </div>
</template>
      
      <script>
import { mapActions, mapState } from "vuex";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
export default {
  name: "product-create",
  components: {
    TiptapVuetify,
  },
  data: () => ({
    record: {},
    foto: "/",
    categories: [],
    subcategories: [],
    units: [],
    criterias: [],
    kinds: [],
    regencies: [],
    districts: [],
    villages: [],
    images: [],
    extensions: [
      History,
      Blockquote,
      Bold,
      Strike,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [
        Heading,
        {
          options: {
            levels: [1, 2, 3],
          },
        },
      ],

      Paragraph,
    ],
  }),
  computed: {
    ...mapState([
      "theme",
      "http",
      "device",
      "records",
      "loading",
      "event",
      "snackbar",
    ]),
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/",
      title: "Produk",
      subtitle: "Manajemen Produk",
      breadcrumbs: [
        {
          text: "Manajemen",
          disabled: true,
          href: "",
        },
        {
          text: "Produk",
          disabled: true,
          href: "",
        },
      ],
      add: false,
      edit: false,
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
      },
      showtable: false,
    });

    this.fetchCategories();
    this.fetchUnits();
    //this.fetchCriterias();
    // this.fetchKinds();
    //this.fetchRegencies();
    this.fetchRecord();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "assignFileBrowse",
      "getUserInfo",
      "initUploadLibrary",
      "setRecord",
      "catchError",
    ]),
    fetchRecord: async function () {
      let { data } = await this.http.get(
        "api/v2/umkm/product/" + this.$route.params.id
      );

      this.record = data ? data : {};

      //this.foto = data.logo_path;
      this.images = data.images;
    },
    posthRecord: async function () {
      try {
        this.record.images = this.images;
        let {
          data: { code, success, message },
        } = await this.http.put(
          "api/v2/umkm/product/" + this.$route.params.id,
          this.record
        );

        if (!success) {
          this.snackbar.color = "red";
          this.snackbar.text = message;
          this.snackbar.state = true;
          return;
        }

        this.snackbar.color = this.theme.color;
        this.snackbar.text = message;
        this.snackbar.state = true;

        this.$router.push({
          name: "umkm-product",
        });
      } catch (error) {
        this.catchError(error);
      }
    },

    uploadFoto: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: {
          doctype: "products",
        },
        callback: (response) => {
          setTimeout(() => {
            this.foto = response.path;
            this.images.push({ path: response.path, name: response.name });
            this.record.images = this.images;
          }, 1000);
        },
      });
    },
    deleteFoto: function (val) {
      this.images.splice(val, 1);
    },

    //custome function
    fetchCategories: async function () {
      try {
        const { data } = await this.http.get("api/v2/combo/category");
        this.categories = data;
      } catch (error) {}
    },
    fetchSubCategories: async function () {
      try {
        let { data } = await this.http.get(
          "api/v2/combo/sub-category/" + this.record.category_uuid
        );

        this.subcategories = data;
      } catch (error) {}
    },
    fetchUnits: async function () {
      try {
        let { data } = await this.http.get("api/v2/combo/unit");
        this.units = data;
      } catch (error) {}
    },
    fetchCriterias: async function () {
      try {
        let { data } = await this.http.get("api/v2/combo/criteria");
        this.criterias = data;
      } catch (error) {}
    },

    fetchKinds: async function () {
      try {
        let { data } = await this.http.get("api/v2/combo/kind");
        this.kinds = data;
      } catch (error) {}
    },
    fetchRegencies: async function () {
      try {
        let { data } = await this.http.get("api/v2/combo/regency");
        this.regencies = data;
      } catch (error) {}
    },
    fetchDistrict: async function () {
      try {
        let { data } = await this.http.get(
          "api/v2/combo/district/" + this.record.regency_code
        );
        this.districts = data;
      } catch (error) {}
    },
    fetchVillages: async function () {
      try {
        let { data } = await this.http.get(
          "api/v2/combo/village/" + this.record.district_code
        );
        this.villages = data;
      } catch (error) {}
    },
  },
  watch: {
    "record.category_uuid": {
      handler() {
        this.fetchSubCategories();
      },
    },
  },
};
</script>
      
    <style></style>
      